(function () {
  if (window.__MM_EXTRAS__) return;
  window.__MM_EXTRAS__ = true;

  var DEBUG = false;
  function log(){ if (DEBUG && window.console) console.log.apply(console, ['[MM-EXTRAS]'].concat([].slice.call(arguments))); }

  var GIFT_ATTR = 'Gift message';
  var BOX_PROP  = 'Box personalisation';

  // Writing textContent is itself a childList mutation. The MutationObserver at
  // the bottom of this file watches childList, so a paint that always writes will
  // re-trigger the observer that called it, forever. Every paint here must be
  // idempotent: write only when the value actually changed. The first cut of this
  // file got this wrong and spammed /cart.js until Shopify answered 429.
  function setText(el, value){
    if (!el) return;
    var v = String(value);
    if (el.textContent !== v) el.textContent = v;
  }

  function setFlag(el, cls, on){
    if (el && el.classList.contains(cls) !== !!on) el.classList.toggle(cls, !!on);
  }

  // ---------------------------------------------------------------------------
  // Cart writes are status-checked. A failed write must never look like a success.
  // ---------------------------------------------------------------------------
  function post(url, body){
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(res){
      return res.json().catch(function(){ return {}; }).then(function(data){
        if (!res.ok) {
          var err = new Error((data && (data.description || data.message)) || ('HTTP ' + res.status));
          err.status = res.status;
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function getCart(){ return fetch('/cart.js').then(function(r){ return r.json(); }); }

  // Only called when a line is added or removed, i.e. when the total actually
  // changes. Property-only edits must NOT refresh: re-rendering the section
  // replaces the input the customer is still typing into.
  function refreshCart(){
    var comp = document.querySelector('cart-items-component[data-section-id]');
    var sectionId = comp ? comp.getAttribute('data-section-id') : null;
    var body = { updates: {} };
    if (sectionId) { body.sections = sectionId; body.sections_url = location.pathname; }

    return post('/cart/update.js', body).then(function(cart){
      var html = sectionId && cart.sections ? cart.sections[sectionId] : null;
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['.cart-page__items', '.cart-page__summary', '.cart-page__extras'].forEach(function(sel){
          var freshNode = doc.querySelector(sel);
          var liveNode  = document.querySelector(sel);
          if (freshNode && liveNode) liveNode.innerHTML = freshNode.innerHTML;
        });
      }
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'mm-extras', data: { source: 'mm-extras', itemCount: cart.item_count, sections: cart.sections || {} } }
      }));
      return cart;
    }).catch(function(e){ log('refresh failed', e); });
  }

  // ===========================================================================
  // Disclosure: "Add free gift message" bar and the "Choose a little extra" rows
  //
  // Both are plain show/hide. No cart traffic, no re-render -- opening a panel
  // must never touch the cart.
  // ===========================================================================
  function toggleDisclosure(btn, panel){
    if (!btn || !panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    panel.hidden = open;

    var label = btn.querySelector('[data-mm-toggle-label]');
    if (label) {
      var showText = label.getAttribute('data-label-show') || label.textContent;
      var hideText = label.getAttribute('data-label-hide') || 'Hide';
      setText(label, open ? showText : hideText);
    }
  }

  document.addEventListener('click', function(ev){
    if (!ev.target || !ev.target.closest) return;

    var extraToggle = ev.target.closest('[data-mm-extra-toggle]');
    if (extraToggle) {
      ev.preventDefault();
      var row = extraToggle.closest('[data-mm-extra]');
      toggleDisclosure(extraToggle, row && row.querySelector('[data-mm-extra-panel]'));
      return;
    }

    var giftToggle = ev.target.closest('[data-mm-gift-toggle]');
    if (giftToggle) {
      ev.preventDefault();
      var panel = document.querySelector('[data-mm-gift-panel]');
      toggleDisclosure(giftToggle, panel);
      var input = document.getElementById('mm-gift-message');
      if (input && !panel.hidden) input.focus();
    }
  });

  // ===========================================================================
  // Gift message -> cart attribute
  // ===========================================================================
  var giftTimer = null;
  var giftInFlight = null;

  function giftEls(){
    return {
      input:  document.getElementById('mm-gift-message'),
      count:  document.getElementById('mm-gift-count'),
      status: document.getElementById('mm-gift-status')
    };
  }

  function paintGiftCount(){
    var e = giftEls();
    if (!e.input || !e.count) return;
    setText(e.count, e.input.value.length);
  }

  function setGiftStatus(text, isError){
    var e = giftEls();
    if (!e.status) return;
    setText(e.status, text || '');
    setFlag(e.status, 'mm-status--error', isError);
  }

  function saveGift(){
    var e = giftEls();
    if (!e.input) return Promise.resolve();
    var value = e.input.value;
    var attrs = {};
    attrs[GIFT_ATTR] = value;

    // No `sections` here on purpose: re-rendering the page mid-typing would rip
    // the textarea out from under the customer's cursor.
    giftInFlight = post('/cart/update.js', { attributes: attrs })
      .then(function(){ setGiftStatus(value.length ? 'Saved' : ''); })
      .catch(function(err){
        log('gift save failed', err);
        setGiftStatus('Not saved — please try again', true);
      })
      .then(function(){ giftInFlight = null; });

    return giftInFlight;
  }

  // ===========================================================================
  // Box personalisation -> line item property on the luxury box line
  // ===========================================================================
  var boxTimer = null;

  function boxEls(){
    return {
      input:  document.getElementById('mm-box-personalisation'),
      count:  document.getElementById('mm-box-personalisation-count'),
      status: document.getElementById('mm-box-personalisation-status')
    };
  }

  function boxConfig(){
    var el = document.getElementById('mm-box-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function luxuryVariantId(){
    var cfg = boxConfig();
    if (!cfg || !Array.isArray(cfg.options)) return null;
    for (var i = 0; i < cfg.options.length; i++) {
      if (cfg.options[i].key === 'luxury') return cfg.options[i].variantId;
    }
    return null;
  }

  function paintBoxCount(){
    var e = boxEls();
    if (!e.input || !e.count) return;
    setText(e.count, e.input.value.length);
  }

  function setBoxStatus(text, isError){
    var e = boxEls();
    if (!e.status) return;
    setText(e.status, text || '');
    setFlag(e.status, 'mm-status--error', isError);
  }

  function personalisationConfig(){
    var cfg = boxConfig();
    return (cfg && cfg.personalisation) || null;
  }

  // `commit` is true only on blur. Adding or removing the paid line changes the
  // total, which forces a section re-render -- doing that on the typing debounce
  // would yank the input out from under the customer mid-word. While typing we
  // only ever update the property of a line that already exists.
  function saveBoxPersonalisation(commit){
    var e = boxEls();
    if (!e.input) return Promise.resolve();

    var value = e.input.value.trim();
    var pers = personalisationConfig();
    var luxVid = luxuryVariantId();

    // No paid product configured: personalisation stays free and rides along as
    // a property on the box line, exactly as it behaved before pricing existed.
    if (!pers) {
      if (!luxVid) return Promise.resolve();
      return getCart().then(function(cart){
        var line = null;
        cart.items.forEach(function(i){ if (!line && i.variant_id === luxVid) line = i; });
        if (!line) { setBoxStatus(''); return; }
        var props = {};
        props[BOX_PROP] = value;
        return post('/cart/change.js', { id: line.key, properties: props })
          .then(function(){ setBoxStatus(value.length ? 'Saved' : ''); });
      }).catch(function(err){
        log('box personalisation failed', err);
        setBoxStatus('Not saved — please try again', true);
      });
    }

    return getCart().then(function(cart){
      var line = null, boxLine = null;
      cart.items.forEach(function(i){
        if (!line && i.variant_id === pers.variantId) line = i;
        if (!boxLine && luxVid && i.variant_id === luxVid) boxLine = i;
      });

      var props = {};
      props[BOX_PROP] = value;

      if (!value) {
        if (!line) { setBoxStatus(''); return; }
        if (!commit) return;
        return post('/cart/change.js', { id: line.key, quantity: 0 })
          .then(refreshCart)
          .then(function(){ setBoxStatus(''); });
      }

      // The charge only makes sense attached to a box.
      if (!boxLine) { setBoxStatus('Choose the keepsake box first'); return; }

      if (line) {
        return post('/cart/change.js', { id: line.key, properties: props })
          .then(function(){ setBoxStatus('Saved'); });
      }

      if (!commit) { setBoxStatus(''); return; }
      return post('/cart/add.js', { id: pers.variantId, quantity: 1, properties: props })
        .then(refreshCart)
        .then(function(){ setBoxStatus('Saved'); });
    }).catch(function(err){
      log('box personalisation failed', err);
      setBoxStatus('Not saved — please try again', true);
    });
  }

  // ===========================================================================
  // Input wiring (delegated, so it survives section re-renders)
  // ===========================================================================
  document.addEventListener('input', function(ev){
    var t = ev.target;
    if (!t) return;

    if (t.id === 'mm-gift-message') {
      paintGiftCount();
      setGiftStatus('');
      if (giftTimer) clearTimeout(giftTimer);
      giftTimer = setTimeout(function(){ giftTimer = null; saveGift(); }, 600);
      return;
    }

    if (t.id === 'mm-box-personalisation') {
      paintBoxCount();
      setBoxStatus('');
      if (boxTimer) clearTimeout(boxTimer);
      boxTimer = setTimeout(function(){ boxTimer = null; saveBoxPersonalisation(false); }, 600);
    }
  });

  document.addEventListener('blur', function(ev){
    var t = ev.target;
    if (!t) return;

    if (t.id === 'mm-gift-message') {
      if (giftTimer) { clearTimeout(giftTimer); giftTimer = null; }
      saveGift();
      return;
    }

    if (t.id === 'mm-box-personalisation') {
      if (boxTimer) { clearTimeout(boxTimer); boxTimer = null; }
      saveBoxPersonalisation(true);
    }
  }, true);

  // ---------------------------------------------------------------------------
  // The section re-renders on every cart mutation, replacing this markup. Only
  // local, non-networked state is repainted here -- deliberately no cart fetch,
  // so a DOM change can never cost a request.
  // ---------------------------------------------------------------------------
  var rafPending = false;
  new MutationObserver(function(){
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function(){
      rafPending = false;
      paintGiftCount();
      paintBoxCount();
    });
  }).observe(document.body, { childList: true, subtree: true });

  function init(){
    paintGiftCount();
    paintBoxCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
